import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title: string;
  titleId?: string;
  desc?: string;
  descId?: string;
  color?: string;
  ariaHidden?: boolean;
  iconSize: 's' | 'm' | 'l' | 'inherit';
  style?: React.CSSProperties;
}
const svgContent = (
  props: React.SVGProps<SVGSVGElement>,
  title?: string,
  titleId?: string,
  desc?: string,
  descId?: string
) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    color="currentColor"
    role="img"
    aria-labelledby={titleId}
    aria-describedby={descId}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M10.207 15.207L3.414 22H8V24H2C0.897 24 0 23.103 0 22V16H2V20.586L8.793 13.793L10.207 15.207ZM22 0H16V2H20.586L13.793 8.793L15.207 10.207L22 3.414V8H24V2C24 0.897 23.103 0 22 0Z"
      fill="currentColor"
    />
  </svg>
);
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  color,
  ...props
}: SVGRProps) => {
  const sizes = {
    s: '12px',
    m: '16px',
    l: '24px',
    inherit: 'inherit', // inherits size from parent
  };
  const size = sizes[iconSize] || 'inherit';
  const style = {
    width: size,
    height: size,
    display: 'flex',
    color: color, // Use the color prop for the icon color
  };
  return (
    <div
      style={style}
      aria-hidden={ariaHidden}
      id={descId ? descId : titleId} // Choose one ID based on what's available
      {...props}
    >
      {svgContent(props, title, titleId, desc, descId)}
    </div>
  );
};
const SvgArrowUpRightAndArrowDownLeftFromCenter = SvgIcon;
export default SvgArrowUpRightAndArrowDownLeftFromCenter;
